import localBase64 from './base64'
import BaseUrl from '@/common/initBaseUrl'

//工单后台请求tab数据对应的按钮文字
export const workOrderTabMapName = {
    // "GDFP": "工单分派",//"工单分派",
    // "JGSH": "结果审核",//"结果审核",
    // "GDQS": "工单签收",//"工单签收",
    // "SQTH": "工单退回",//"工单退回",
    // "THSH": "退回审核",//"退回审核",
    // "GDDB": "工单督办",//"工单督办",
    // "GDGD": "工单签收",//"工单签收",
    // "DBCC": "结果审核",//"结果审核",
    // "GDCZ": "工单处置",//"工单处置",
    "GDFP": "工单分派",//"工单分派",
    "JGSH": "结果审核",//"结果审核",
    "GDQS": "工单签收",//"工单签收",
    "GDTH": "工单退回",//"工单退回",
    "GDCZ": "工单处置",//"工单处置",
    "THSH": "退回审核",//"退回审核",
    "GDDB": "工单督办",//"工单督办",
    "GDGD": "工单归档",//"工单归档",
    "DBCC": "督办抽查",//"督办抽查",
    "GDGP":"工单改派",//工单改派
    "GDTS":"工单推送",//工单推送
    "CXFP":"重新分派",//"重新分派",
    "GDYQ":"工单延期",//"工单延期",
    "GDBH":"工单驳回",//"工单驳回",
    "GDJP":"工单加派",//"工单加派",
    "CXFQ":"重新发起",//"重新发起",
    "HGJC":"合格检查",//"合格检查",
}
//工单后台请求tab数据对应的组件名
export const workOrderTabMapComponent = {
    // "CZJGSH_ZGLD": "Workorder_CZJGSH_ZGLD",//"处置结果审核",
    // "CZJGSH_ZX": "Workorder_CZJGSH_ZX",//"处置结果审核",
    // "GDHF_ZX": "Workorder_GDHF_ZX",//"处置结果审核",
    // "GDHF": "Workorder_GDHF",//"工单回访",
    // "GDPS": "Workorder_GDPS",//"工单批示",
    // "PSTS": "Wordorder_PSTS",//"批示推送",
    // "TJCZJG": "Workorder_TJCZJG",//"工单回访",

    "GDFP": "Workorder_GDFP",//"工单分派",
    "JGSH": "Workorder_JGSH",//"结果审核",
    "GDQS": "Workorder_GDQS",//"工单签收",
    "GDTH": "Workorder_GDTH",//"工单退回",
    "GDCZ": "Workorder_GDCZ",//"工单处置",
    "THSH": "Workorder_THSH",//"退回审核",
    "GDDB": "Workorder_GDDB",//"工单督办",
    "GDGD": "Workorder_GDGD",//"工单归档",
    "DBCC": "Workorder_DBCC",//"督办抽查",
    "GDGP":"Workorder_GDGP",//工单改派
    "GDTS":"Workorder_GDTS",//工单推送
    "CXFP":"Workorder_CXFP",//"重新分派",
    "GDYQ":"Workorder_GDYQ",//"工单延期",
    "CXFQ":"Workorder_CXFQ",//"重新发起",
    "GDBH":"Workorder_GDBH",//"工单驳回",
    "GDJP":"Workorder_GDJP",//"工单加派",
    "XGLX":"Workorder_XGLX",//"修改类型",
    "HGJC":"Workorder_HGJC",//"合格检查",
}
//工单后台请求tab数据对应的图标
export const workOrderTabIcon = {
    // "CZJGSH_ZGLD": "ico_szjgsh",//"处置结果审核",
    // "CZJGSH_ZX": "ico_czjgsh",//"处置结果审核",
    // "GDHF_ZX": "ico_czjgsh",//"处置结果审核",
    // "GDFP": "ico_gdfp",//"工单分派",
    // "GDHF": "ico_gdhf",//"工单回访",
    // "GDPS": "ico_gdpf",//"工单批示",
    // "GDQS": "ico_gdqs",//"工单签收",
    // "PSTS": "ico_psts",//"批示推送",
    // "SQTH": "ico_sqth",//"申请退回",
    // "THSH": "ico_thsh",//"退回审核",
    // "TJCZJG": "ico_gdhf",//"工单回访",
    "GDFP": "ico_gdfp",//"工单分派",
    "JGSH": "ico_czjgsh",//"结果审核",
    "GDQS": "ico_gdqs",//"工单签收",
    "GDTH": "ico_gdth",//"工单退回",
    "GDCZ": "ico_gdcz",//"工单处置",
    "THSH": "ico_thsh",//"退回审核",
    "GDDB": "ico_gddb1",//"工单督办",
    "GDGD": "ico_gdgd",//"工单归档",
    "DBCC": "ico_dbcc",//"督办抽查",
    "GDGP":"ico_gdfp",//工单改派
    "GDTS":"ico_psts",//工单推送
    "CXFP":"ico_gdfp",//"重新分派",
    "GDYQ":"ico_gdyq",//"工单延期",
    "CXFQ":"ico_gdfp",//"重新发起",
    "GDBH":"ico_gdbh",//"工单驳回",
    "GDJP":"ico_gdjp",//"工单加派",
    "XGLX":"ico_cxxg",//"修改类型",
    "HGJC":"ico_cxxg",//"合格检查",
}
//处置流程
export const timeLineToComponent = {
    // "CJGD": "TimeLine_CJGD",
    // "PSTS": "TimeLine_PSTS",
    // "GDPS": "TimeLine_GDPS",
    // "GDHF": "TimeLine_GDHF",
    // "TJCZJG": "TimeLine_TJCZJG",
    // "GDCB": "TimeLine_GDCB",
    // "GDDB": "TimeLine_GDDB",
    // "SQTH": "TimeLine_SQTH",
    // "THSH": "TimeLine_THSH",
    // "CZJGSH": "TimeLine_CZJGSH",
    // "GDBJ": "TimeLine_OVER",
    // "GDZCL":"TimeLine_GDZCL",

    "GDFP": "TimeLine_GDFP",//"工单分派",
    "JGSH": "TimeLine_JGSH",//"结果审核",
    "GDQS": "TimeLine_GDQS",//"工单签收",
    "GDTH": "TimeLine_GDTH",//"工单退回",
    "GDCZ": "TimeLine_GDCZ",//"工单处置",
    "THSH": "TimeLine_THSH",//"退回审核",
    "GDDB": "TimeLine_GDDB",//"工单督办",
    "GDGD": "TimeLine_GDGD",//"工单归档",
    "DBCC": "TimeLine_DBCC",//"督办抽查",
    "CJGD": "TimeLine_CJGD",//"督办抽查",
    "GDGP": "TimeLine_GDGP",//"工单改派",
    "GDTS": "TimeLine_GDTS",//"工单推送",

    "CXFP":"TimeLine_CXFP",//"重新分派",
    "GDJP":"TimeLine_GDJP",//"工单加派",
    "CXFQ":"TimeLine_CXFQ",//"重新发起",
    "GDCB":"TimeLine_GDCB",//"工单催办",
    "GDBH":"TimeLine_GDBH",//"工单驳回",
    "GDXG":"TimeLine_GDXG",//"工单修改",
    "XGLX":"TimeLine_XGLX",//"工单类型",
    "JPDW":"TimeLine_JPDW",//"减派单位",
    "HGJC":"TimeLine_HGJC",//"合格检查",

    // "GDYQ":"TimeLine_GDYQ",//"工单延期",
}
//时间格式化YYYY-MM-DD HH:mm:ss
export const dateFormat = function (timestamp) {
    if (timestamp !== '') {
        const time = new Date(timestamp)
        const numRange = function (num) {
            return (num < 10 ? '0' : '') + num
        }
        return numRange(time.getFullYear()) + "-" + numRange(time.getMonth() + 1) + "-" + numRange(time.getDate()) + " " + numRange(time.getHours()) + ":" + numRange(time.getMinutes()) + ":" + numRange(time.getSeconds())
    }
    return ""
}
//文件下载
export const fileDownload =(param)=>{
    let a = document.createElement('a');
    a.setAttribute('href', "/jgfast/sys/comm/download?fileId="+param);
    a.click();
    a.remove();
}

//文件预览
export const filePreview =(fileName,id)=>{
    let originUrl = document.location.origin+'/jgfast/sys/comm/fileUploadView?fileId='+id; //要预览文件的访问地址
    let previewUrl = originUrl + '&fullfilename='+id+fileName;//预览服务内部文件名，加上id避免同名文件显示错误
    window.open(BaseUrl.filePreviewUrl+'/onlinePreview?url='+encodeURIComponent(localBase64.encode(previewUrl)));
}

//文件预览
export const filePreviewByUrl =(url,fileName,id)=>{
    let previewUrl = url + '?fullfilename='+id+fileName;
    window.open(BaseUrl.filePreviewUrl+'/onlinePreview?url='+encodeURIComponent(localBase64.encode(previewUrl)));
}
